<template>
<div class="chapter">
<div class="inner_page">
<p class="chap-title"><a id="page7"></a>Who’s Who</p>
<p class="number">1</p>
<p class="noindent">Yeats saw a fish</p>
<p class="noindents">as a mysterious girl</p>
<p class="noindent">which made the world seem</p>
<p class="noindents">more fuckable.</p>
<p class="noindent">He wanted to follow her</p>
<p class="noindents">home</p>
<p class="noindents">after he killed her,</p>
<p class="noindent">but, of course, did not.</p>
<p class="number">2</p>
<p class="noindent">“Here’s the thing,”</p>
<p class="noindents">says the brand spokesmodel</p>
<p class="noindent">waving her Diet Coke</p>
<p class="noindent">and sounding beleaguered</p>
<p class="noindents">yet defiant,</p>
<p class="noindent">“just do <span class="font-i">you</span>”</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 011_Chapter004.vue?2f98f317